import { canAccessUsageAnalytics, isHorizonRootRole } from "./horizonRoles";

export function isBillingUiVisible(msp: { role?: string; credit_billing_enabled?: boolean } | null | undefined): boolean {
  return isHorizonRootRole(msp?.role) || (msp?.credit_billing_enabled === true && canAccessUsageAnalytics(msp?.role));
}
